/* EVHouse optional basket recommendations v1. No automatic additions or tracking tags. */
(function () {
  'use strict';
  const products = Object.freeze({
    '8850964578630': { trigger: '9284204101958', variants: ['49365413691718', '49365413757254'] },
    '8884301496646': { trigger: '9284204101958', variants: ['49385024782662', '49385024815430'] },
    '15243169333574': { triggers: ['8948404748614', '15548810232134'], variants: ['55394447065414'] }
  });
  function validateChoice(cart, productId, variantId) {
    const rule = products[String(productId)];
    if (!rule || !rule.variants.includes(String(variantId))) return 'invalid';
    if (!Array.isArray(cart.items)) return 'invalid';
    const triggers = rule.triggers || [rule.trigger];
    if (!cart.items.some(item => triggers.includes(String(item.product_id)) && item.quantity > 0)) return 'trigger-removed';
    if (cart.items.some(item => String(item.product_id) === String(productId) && item.quantity > 0)) return 'already-added';
    return 'ok';
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { validateChoice, products };
  if (typeof window === 'undefined' || customElements.get('evh-smart-cart-addons')) return;
  let adding = false;
  let uncertain = false;
  const componentSelector = 'evh-smart-cart-addons';
  async function readJSON(url, options) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal });
      const data = await response.json();
      if (!response.ok || data.status >= 400) {
        const error = new Error('shopify-rejected');
        // A normal validation rejection is known not to require a blind retry.
        error.rejected = response.status === 422 || response.status === 400;
        throw error;
      }
      return data;
    } finally { clearTimeout(timeout); }
  }
  function plans() {
    const list = [];
    const main = document.getElementById('main-cart-items');
    if (main?.dataset.id) {
      list.push({ id: main.dataset.id, target: '#main-cart-items .js-contents', source: '.js-contents' });
      list.push({ id: main.dataset.id, target: '#main-cart-footer .cart__footer__js-contents', source: '.cart__footer__js-contents' });
    }
    if (document.querySelector('cart-drawer')) {
      list.push({ id: 'cart-drawer', target: 'cart-drawer .cart-drawer__items', source: '.cart-drawer__items' });
      list.push({ id: 'cart-drawer', target: 'cart-drawer .cart-drawer__footer--subtotal', source: '.cart-drawer__footer--subtotal' });
    }
    if (document.getElementById('cart-icon-bubble')) {
      // Match the native theme: replace the anchor contents, not the anchor/listeners.
      list.push({ id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' });
    }
    return list.filter(plan => document.querySelector(plan.target));
  }
  function repaint(sections, plan) {
    const parser = new DOMParser();
    // Validate every fragment before changing anything. Never replace invoice inputs.
    const replacements = plan.map(part => {
      const html = sections?.[part.id];
      if (typeof html !== 'string') throw new Error('missing-section');
      const source = parser.parseFromString(html, 'text/html').querySelector(part.source);
      const target = document.querySelector(part.target);
      if (!source || !target) throw new Error('missing-section-target');
      return { target, html: source.innerHTML };
    });
    replacements.forEach(part => { part.target.innerHTML = part.html; });
  }
  function setBusy(busy) {
    document.querySelectorAll(componentSelector).forEach(element => {
      element.setAttribute('aria-busy', String(busy));
      element.querySelectorAll('[data-addon-card]').forEach(card => {
        const select = card.querySelector('[data-addon-variant]');
        select.disabled = busy || uncertain;
        card.querySelector('[data-addon-add]').disabled = busy || uncertain || !select.value;
      });
    });
  }
  class EVHouseSmartAddons extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('change', event => {
        if (!event.target.matches('[data-addon-variant]')) return;
        // Native CartItems treats any bubbled change as a quantity update.
        event.stopPropagation();
        this.updateCard(event.target.closest('[data-addon-card]'));
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-addon-add]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        this.add(button.closest('[data-addon-card]'));
      });
      this.querySelectorAll('[data-addon-card]').forEach(card => this.updateCard(card));
    }
    updateCard(card) {
      const select = card.querySelector('[data-addon-variant]');
      const option = select.selectedOptions[0];
      card.querySelector('[data-addon-price]').textContent = option?.dataset.money || 'Επιλέξτε παροχή';
      card.querySelector('[data-addon-add]').disabled = !select.value || adding || uncertain;
    }
    status(message, error, recovery) {
      const output = this.querySelector('[data-addon-status]');
      if (!output) return;
      output.textContent = message;
      output.dataset.error = String(!!error);
      if (recovery) {
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = ' Δείτε το καλάθι σας';
        output.append(link);
      }
    }
    async add(card) {
      if (adding || uncertain) return;
      const select = card.querySelector('[data-addon-variant]');
      const selected = select.selectedOptions[0];
      const variantId = select.value;
      if (!variantId) return;
      const productId = card.dataset.productId;
      const root = (this.dataset.cartRoot || '/').replace(/\/?$/, '/');
      const context = this.dataset.context;
      const cartURL = this.dataset.cartUrl;
      const selectedPrice = Number(selected.dataset.price);
      let attempted = false;
      let added = false;
      adding = true;
      setBusy(true);
      this.status('Ελέγχουμε την επιλογή σας…');
      try {
        const cart = await readJSON(root + 'cart.js');
        const validation = validateChoice(cart, productId, variantId);
        if (validation !== 'ok') {
          this.status(validation === 'already-added' ? 'Το αξεσουάρ υπάρχει ήδη στο καλάθι σας.' : 'Το καλάθι άλλαξε. Ελέγξτε τα προϊόντα πριν συνεχίσετε.', false, true);
          return;
        }
        const product = await readJSON(root + 'products/' + encodeURIComponent(card.dataset.productHandle) + '.js');
        const variant = product.variants?.find(item => String(item.id) === variantId);
        if (String(product.id) !== productId || !variant?.available || variant.price <= 0) {
          this.status('Η επιλογή δεν είναι πλέον διαθέσιμη. Δείτε τις επιλογές στη σελίδα του προϊόντος.', true);
          return;
        }
        if (variant.price !== selectedPrice) {
          this.status('Η τιμή ενημερώθηκε. Ανοίξτε ξανά το καλάθι για να δείτε τη νέα τιμή πριν την προσθήκη.', true, true);
          return;
        }
        const plan = plans();
        if (!plan.length) throw new Error('missing-cart-ui');
        this.status('Προσθήκη στο καλάθι…');
        attempted = true;
        const result = await readJSON(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: { _evh_addon_source: 'smart_cart_v1' } }], sections: [...new Set(plan.map(part => part.id))], sections_url: window.location.pathname })
        });
        added = true;
        repaint(result.sections, plan);
        // Generic theme suggestions are non-critical; their failure must not mask a successful add.
        try { document.querySelector('cart-drawer')?.updateProductRecommendation?.(); } catch (_) {}
        const newComponent = document.querySelector(componentSelector + '[data-context="' + context + '"]');
        if (newComponent) {
          newComponent.status('Προστέθηκε. Το καλάθι και το σύνολο ενημερώθηκαν.');
          newComponent.querySelector('[data-addon-status]')?.focus({ preventScroll: true });
        } else {
          const region = document.getElementById(context === 'drawer' ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text');
          if (region) { region.textContent = 'Το αξεσουάρ προστέθηκε στο καλάθι.'; region.setAttribute('aria-hidden', 'false'); }
          const next = context === 'drawer' ? document.querySelector('cart-drawer .cart-item__name') : document.querySelector('#main-cart-items .cart-item__name');
          next?.focus({ preventScroll: true });
        }
        // A DOM-only integration event: no analytics transmission or fabricated purchase.
        document.dispatchEvent(new CustomEvent('evh:smart-addon-added', { detail: { productId, variantId, context } }));
      } catch (error) {
        if (attempted && !error.rejected) {
          // An interrupted response can hide a successful POST. Do not risk adding twice.
          uncertain = true;
          this.status(added ? 'Το αξεσουάρ προστέθηκε, αλλά η προβολή δεν ανανεώθηκε. Ελέγξτε το καλάθι πριν συνεχίσετε.' : 'Δεν επιβεβαιώθηκε η προσθήκη. Ελέγξτε το καλάθι πριν δοκιμάσετε ξανά.', true, true);
        } else {
          this.status(error.rejected ? 'Δεν έγινε η προσθήκη. Η διαθεσιμότητα μπορεί να άλλαξε· ελέγξτε το προϊόν και δοκιμάστε ξανά.' : 'Δεν ήταν δυνατός ο έλεγχος. Δοκιμάστε ξανά σε λίγο ή συνεχίστε με το καλάθι σας.', true, false);
        }
      } finally {
        adding = false;
        setBusy(false);
      }
    }
  }
  customElements.define('evh-smart-cart-addons', EVHouseSmartAddons);
}());
